import React, { useState } from "react";
import { useTransition, animated } from "react-spring";
import ProgressBar from "../../ProgressBar";
import { stepStyles } from "../formStyles";

export const WhatIsYourGoal = ({ formData, setForm, navigation, step }) => {
  const [error, setError] = useState(false);

  const refinanceGoals = [
    {
      id: "Lower interest rate or change terms ",
      title: "Lower interest rate or change terms ",
    },
    {
      id: "Cash out for home improvements",
      title: "Cash out for home improvements",
    },
    {
      id: "Cash out for a major purchase ",
      title: "Cash out for a major purchase ",
    },
    {
      id: "Eliminate mortgage insurance ",
      title: "Eliminate mortgage insurance ",
    },
    { id: "Consolidate debt", title: "Consolidate debt" },
  ];

  const checkForNextStep = () => {
    if (formData.refinanceGoals === "") {
      setError(true);
      console.log("error");
    }
    if (formData.refinanceGoals !== "") {
      navigation.next();
      console.log("next");
    }
  };
  const [isVisible] = useState(true);

  const transition = useTransition(isVisible, {
    from: { opacity: 0, transform: "translate3d(500px,0px,0)" },
    enter: { opacity: 1, transform: "translate3d(0,0px,0)" },
  });

  return (
    <div className={stepStyles.page}>
      <ProgressBar width={"25%"} />
      <div className={stepStyles.content}>
        {transition((style, item) =>
          item ? (
            <animated.div style={style} className={stepStyles.panel}>
              <h1 className={stepStyles.title}>What is your refinancing goal?</h1>
              <div className="w-full">
                <label className="text-base font-medium text-gray-900"></label>
                <fieldset className="">
                  <legend className="sr-only">What is your refinancing goal?</legend>
                  <div className={stepStyles.optionGroup}>
                    {refinanceGoals.map((refinanceGoal) => (
                      <label key={refinanceGoal.id} className={stepStyles.optionRow}>
                        <input
                          onChange={setForm}
                          value={refinanceGoal.id}
                          id={refinanceGoal.id}
                          name="refinanceGoals"
                          type="radio"
                          className={stepStyles.radio}
                        />
                        <span className={stepStyles.label}>{refinanceGoal.title}</span>
                      </label>
                    ))}
                  </div>
                  {error ? <p className={stepStyles.error}>please fill out an answer</p> : null}
                </fieldset>
              </div>
            </animated.div>
          ) : null,
        )}
      </div>
      <div className={stepStyles.actionBar}>
        <div className={stepStyles.actionRow}>
          <div className="w-full md:w-auto">
            <button className={`${stepStyles.button} w-full`} onClick={() => checkForNextStep()}>
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
